class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {

      const dropdown = event.target.closest('select[name="sw-cart-drawer-selling-plan"]');
      if (dropdown) {
        return;
      }

      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
      const cartWasActualized = await this.applyUpsellDiscount(event);
      if (event.source === 'cart-items') {
        return;
      }
      if (event.source === 'product-form' && !cartWasActualized) {
        return;
      }
      this.onCartUpdate(event);
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  async getCart () {
    try {
      const response = await fetch(`${routes.cart_url}.js`);
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error?.message ?? 'Unexpected error');
      }
      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  async applyUpsellDiscount(event) {
    const cart = await this.getCart();
    return await this.actualize(cart, event);

  }

  async applyDiscount (code = '') {
    let formData = new FormData();
    formData.append('discount', code);
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log(data);
      return data;
    } catch (error) {
      console.error('Error updating cart:', error);
      return null;
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

   onCartUpdate (event) {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`).then((response) => response.text()).then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = [
          'cart-drawer-items',
          '.cart-drawer__footer',
          '.sw-cart-drawer-shipping-bar-container',
        ];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      }).catch((e) => {
        console.error(e);
      });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`).
        then((response) => response.text()).
        then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        }).
        catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) {
          cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
          cartDrawerWrapper.classList.toggle('sw-is-empty', parsedState.item_count === 0);
        }
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          const contentDom = this.getContentDom(
            parsedState.sections[section.section],
          section.selector,
          );
          const contentDomInner = contentDom.querySelectorAll('.drawer__inner > div');
          const contentDomInnerFooter = contentDom.querySelectorAll('.drawer__inner > div.drawer__footer > div');
          let inner = true;
          if (section.section === 'cart-drawer' && contentDomInner.length && contentDomInnerFooter.length) {
            try {
              elementToReplace.querySelectorAll('.drawer__inner > div').forEach((item, index) => {
                if (item.classList.contains('drawer__footer')) {
                  item.classList = contentDomInner[index].classList;
                  item.parentNode.querySelectorAll('.drawer__footer > div').forEach((footerItem, footerIndex) => {
                    if (!footerItem.classList.contains('additional-checkout-buttons')) {
                      footerItem.parentNode.replaceChild(contentDomInnerFooter[footerIndex], footerItem);
                    }
                  });
                } else {
                  item.parentNode.replaceChild(contentDomInner[index], item);
                }
              });
              inner = false;
            } catch (e) {
              inner = true;
            }
          }
          if (inner === true) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
            section.selector,
            );
          }
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  
  async actualize (parsedState, event) {
    const upsellItems = parsedState.items.filter((item) => {
      return item.hasOwnProperty('properties') && ((item.properties.hasOwnProperty('_bundled_with') && item.properties.hasOwnProperty('_bundled_discount_code') &&
        item.properties._bundled_with && item.properties._bundled_discount_code) || (item.properties.hasOwnProperty('_bundled_for') && item.properties._bundled_for));
    });
    const discountCodes = {
      'toApply': [],
      'toRemove': [],
    };


    if (upsellItems.length) {
      upsellItems.forEach(upsellItem => {
        let upsellForID, upsellDiscountCode;
        if(upsellItem.hasOwnProperty('properties')) {
          if(upsellItem.properties.hasOwnProperty('_bundled_with') && upsellItem.properties.hasOwnProperty('_bundled_discount_code')) {
            upsellForID = upsellItem.properties['_bundled_with'] * 1;
            upsellDiscountCode = upsellItem.properties['_bundled_discount_code'];
            const targetItem = parsedState.items.find((item) => {
              const itemID = item.id * 1;
              return itemID === upsellForID;
            });
            if(!targetItem) {
              if (!discountCodes.toRemove.includes(upsellDiscountCode)) {
                discountCodes.toRemove.push(upsellDiscountCode);
              }
            } else if(!discountCodes.toApply.includes(upsellDiscountCode)) {
              discountCodes.toApply.push(upsellDiscountCode);
            }
          } else if(upsellItem.properties.hasOwnProperty('_bundled_for')) {
            upsellForID = upsellItem.properties['_bundled_for'] * 1;
            const targetItem = parsedState.items.find((item) => {
              const itemID = item.id * 1;
              return itemID === upsellForID;
            });
            if(!targetItem) {
              if (upsellItem.properties.hasOwnProperty('_bundled_for_discount_code')) {
                upsellDiscountCode = upsellItem.properties['_bundled_for_discount_code'];
                if (!discountCodes.toRemove.includes(upsellDiscountCode)) {
                  console.log('push to remove');
                  discountCodes.toRemove.push(upsellDiscountCode);
                }
              }
            }else{
              upsellDiscountCode = targetItem.properties.hasOwnProperty('_bundled_discount_code')?targetItem.properties['_bundled_discount_code']:null;
              if(upsellDiscountCode && !discountCodes.toApply.includes(upsellDiscountCode)) {
                discountCodes.toApply.push(upsellDiscountCode);
              }
            }
          }
        }
      });
    }

    let renew = false;
    let toApply = parsedState?.discount_codes ?? [];

    const toRemove = discountCodes.toRemove.filter((item) => {
      return !discountCodes.toApply.includes(item) && toApply.find((discount) => discount.code === item);
    });

    if (toRemove.length) {
      console.log('reset');
      await this.applyDiscount('');
      renew = true;
    }

    toApply = toApply.filter((item) => {return !toRemove.includes(item.code);});
    toApply = toApply.map((item) => item.code);
    const newDiscountCodes = discountCodes.toApply.filter((item) => {
      return !toApply.includes(item);
    });

    if (newDiscountCodes.length) {
      toApply = [...new Set([...toApply, ...newDiscountCodes])];
    }
    console.log('discounts to apply', toApply.join(','));
    if ((toRemove.length || newDiscountCodes.length) && toApply.length) {
      await this.applyDiscount(toApply.join(','));
      renew = true;
    }
    if(renew && event.source === 'cart-items') {
      this.onCartUpdate(event);
    }
    return renew;
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getContentDom(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER),
        );
      }
    },
  );
}
